import {
  CreateSubscriptionRequest,
  LineItem,
  Metadata,
  Subscription
} from "../proto/payments_pb"
/**
 * Build create request object
 */
export const getSubscriptionRequestObject = (data) => {
  // destract params
  const {
    paymentMethodTypes = ["card"],
    lineItems = [],
    mode = "subscription",
    metadata = {},
    priceType,
    successUrl,
    cancelUrl
  } = data

  // init request
  const request = new CreateSubscriptionRequest()

  // set payment method
  if (paymentMethodTypes.length)
    request.setPaymentMethodTypesList(paymentMethodTypes)

  // set line items
  const lineItemsList = lineItems.map((item) => {
    const lineItemObj = new LineItem()
    lineItemObj.setQuantity(item.quantity)
    return lineItemObj
  })
  request.setLineItemsList(lineItemsList)

  // set mode
  if (mode) request.setMode(mode)

  // set success redirect url
  if (successUrl) request.setSuccessUrl(successUrl)

  // set failer redirect url
  if (cancelUrl) request.setCancelUrl(cancelUrl)

  // set price type
  if (priceType) request.setPriceType(priceType)

  // set metadata
  if (Object.keys(metadata).length) {
    const metadataObj = new Metadata()
    metadataObj.setOrgId(metadata.orgId)
    request.setMetadata(metadataObj)
  }

  // returns request
  return request
}

/**
 * Get subscription object
 */
export const getSubscriptionObject = (data) => {
  const subscription = new Subscription()

  if (data.quantity) subscription.setQuantity(data.quantity)

  return subscription
}
